module.exports = __webpack_public_path__ + "img/c07_unitulfhednar_Normal_ua.1fe359e4.webp";